import { MARK_FIRST_USER_INTERACTION } from './userInteractionActions';

const defaultState = {
    hasUserInteracted: false,
};

const userInteractionReducer = (state = defaultState, action) => {
    switch (action.type) {
        case MARK_FIRST_USER_INTERACTION:
            return {
                ...state,
                hasUserInteracted: true,
            };
        default:
            return state;
    }
};

export default userInteractionReducer;
